module.exports = {
  userInfo: {
    logout: "Logout",
    changeAvatar: "Change Avatar",
    firstName: "First Name",
    lastName: "Last Name",
    sex: "Sex",
    male: "Male",
    female: "Female",
    dateOfBirth: "Date Of Birth",
    bindPhoneNumber: "Bind Phone Number",
    change: "Change",
    saveBtn: "Save",
    editProfile: "Edit Profile",
    decTitle: "View and edit your personal information below.",
    userId: "User ID:",
    accountEmail: "Account Email Address:",
    changePassword: "Change Password",
    changeAccount: "Change Account Email Address",
    email: "Contact Email",
    phone: "Phone Number(ex.201-555-5555)",
    gender: "Gender",
    birthday: "Birthday",
    cancel: "Cancel",
    currentPassword: "Enter Current Password",
    newPassword: "Enter New Password",
    againNewPassword: "Enter New Password Again",
    currentEmail: "Enter Current Email Address",
    emailCode: "Enter the Verification Code",
    newEmail: "Enter New Email Address",
    titlePassword: "Change Password",
    titleEmail: "Change Account Email Address",
    sendCode: "Send Code",
  },
  changePhone: {
    changePhoneNumber: "Change Phone Number",
    authentication: "Authentication",
    complete: "Complete",
    boundPhoneNumber: "Bound Phone Number",
    verificationCode: "Verification Code",
    nextStep: "Next Step",
    enterNewNumber: "Enter New Number",
    sumbit: "Sumbit",
    congratulations: "Congratulations, the replacement of the phone is complete!",
    securityServiceTips: "Security Service Tips",
    bindingSecurity: "Binding a mobile phone can improve account security",
    phoneAccount: "A mobile phone number can only be bound to one account",
  },
  message: {
    noNews: "You have no news yet~",
    goHomepage: "Go to the homepage to see",
    noOders: "You have no order yet~",
    noQuestions: "You haven't asked any questions yet~",
    noAnswer: "You haven't answered yet~",
    noSalesOrder: "You have no after-sales order yet~",
    noCommented: `You haven't commented yet~`,
    noBrowsing: "You have no browsing history yet~",
  },
  order: {
    allOrders: "All Orders",
    pendingPayment: "Pending Payment",
    beShipped: "Be Shipped",
    beReceived: "Be Received",
    beEvaluated: "Be Evaluated",
    beGrouped: "Be Grouped",
    commoditySearch: "Commodity Name/Order Number",
    commodity: "Commodity",
    unitPrice: "Unit Price",
    amount: "Amount",
    receiver: "Receiver",
    realPayment: "Real Payment",
    state: "State",
    operate: "Operate",
    orderNumber: "Order Number",
    afterSalesReview: "After-sales Review",
    refunding: "Refunding",
    returning: "Returning",
    refundSuccessfully: "Refund Successfully",
    refundFailed: "Refund Failed",
    auditNotPassed: "Audit Not Passed",
    aftermarketReviewIn: "Aftermarket Review In",
    refundRefused: "The return is complete, and the refund is refused",
    reviewPassed: "After-sales Review Passed",
    includingFreight: "Including Shipping",
    remainingTime: "Remaining Time",
    minute: "Minute",
    completed: "Completed",
    closed: "Closed",
    orderDetails: "Order Details",
    afterDdetails: "After-sale Details",
    toPay: "To Pay",
    remindShipment: "Remind Shipment",
    confirmationReceipt: "Confirmation Of Receipt",
    buyAgain: "Buy Again",
    cancelOrder: "cancelOrder",
    returnRefund: "Return/Refund",
    evaluation: "Evaluation",
    checkLogistics: "Check Logistics",
  },
  qalist: {
    myQuestion: "My Question",
    noAnswer: "No Answer",
    myAnswer: "My Answer",
    answerTo: "Answer To",
  },
  orderAfterSale: {
    afterSale: "After Sale",
    completed: "Completed",
    refundAmount: "Refund Amount",
    applicationTime: "Application Time",
    afterSalesNumber: "After-sales Number",
    platformIntervention: "Apply For Platform Intervention",
  },
  myEvaluate: {
    evaluationTime: "Evaluation Time",
    viewReviews: "View Reviews",
    toReview: "To Review",
    myComment: "My Evaluation",
    evaluationDetails: "Evaluation Details",
    initialEvaluation: "Initial Evaluation",
    additionalEvaluation: "Additional Evaluation",
    fillEvaluation: "Fill In Product Evaluation",
    pleaseComment: "Please enter your comment",
    inTotal: "In Total",
    sheet: "Sheet",
    alsoUpload: "Can Also Upload",
    submitReview: "Submit Review",
    myOrder: "My Order",
    evaluation: "Evaluation",
    productSatisfactionScore: "Product Satisfaction Score",
    commodityImpression: "Commodity Impression",
    evaluationList: "Evaluation List",
  },
  browseRecords: {
    browseFootprint: "Browse Footprint",
    deleteFootprint: "Delete",
    seeDetails: "See Details",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/userCenter/index.js